import { Button } from '@orbind/ui'
import { useState } from 'react'
import type { PerguntaDoAssistente } from './useAssistente.ts'

/**
 * Pergunta de decisão do Orbind AI (SPEC-20261104-2229): as opções que o
 * Orbind AI leu do workspace, a recomendada primeiro e marcada com o motivo.
 * Uma escolha manda a resposta na hora; na pergunta de várias escolhas a
 * pessoa marca e clica em "Responder". Escrever na caixa também responde.
 */

export function textoDaEscolha(escolhidas: string[]): string {
  if (escolhidas.length <= 1) return escolhidas[0] ?? ''
  return `${escolhidas.slice(0, -1).join(', ')} e ${escolhidas.at(-1)}`
}

export function CartaoDePergunta(props: {
  pergunta: PerguntaDoAssistente
  /** O que foi respondido — o cartão fica só de leitura. */
  respondida?: string
  ocupado: boolean
  onResponder: (resposta: string) => void
}) {
  const { pergunta, respondida, ocupado, onResponder } = props
  const [marcadas, setMarcadas] = useState<string[]>([])
  const fechada = respondida !== undefined

  const escolher = (rotulo: string) => {
    if (fechada || ocupado) return
    if (!pergunta.multipla) return onResponder(rotulo)
    setMarcadas((m) => (m.includes(rotulo) ? m.filter((r) => r !== rotulo) : [...m, rotulo]))
  }

  return (
    <div className={`ast-perg${fechada ? ' ast-perg--fechada' : ''}`} role="group" aria-label={pergunta.pergunta}>
      <p className="ast-perg__titulo">
        <i className="far fa-question-circle" aria-hidden /> {pergunta.pergunta}
      </p>
      <div className="ast-perg__opcoes">
        {pergunta.opcoes.map((o) => {
          const escolhida = fechada
            ? respondida === o.rotulo || (pergunta.multipla && (respondida ?? '').includes(o.rotulo))
            : marcadas.includes(o.rotulo)
          return (
            <button
              key={o.rotulo}
              type="button"
              className={`ast-perg__opcao${o.recomendada ? ' ast-perg__opcao--recomendada' : ''}${escolhida ? ' ast-perg__opcao--escolhida' : ''}`}
              aria-pressed={pergunta.multipla || fechada ? escolhida : undefined}
              disabled={fechada || ocupado}
              onClick={() => escolher(o.rotulo)}
            >
              <span className="ast-perg__marca" aria-hidden>
                {escolhida ? <i className="fas fa-check" /> : pergunta.multipla ? <i className="far fa-square" /> : <i className="far fa-circle" />}
              </span>
              <span className="ast-perg__texto">
                <span className="ast-perg__rotulo">
                  {o.rotulo}
                  {o.recomendada ? (
                    <span className="ast-perg__selo">
                      <i className="fas fa-star" aria-hidden /> Recomendada
                    </span>
                  ) : null}
                </span>
                {o.descricao ? <span className="ast-perg__descricao">{o.descricao}</span> : null}
              </span>
            </button>
          )
        })}
      </div>
      {pergunta.motivo ? (
        <p className="ast-perg__motivo">
          <strong>Por que a recomendada:</strong> {pergunta.motivo}
        </p>
      ) : null}
      {fechada ? null : pergunta.multipla ? (
        <div className="ast-perg__acoes">
          <Button size="sm" variant="primary" icon="fas fa-check" disabled={!marcadas.length || ocupado} onClick={() => onResponder(textoDaEscolha(marcadas))}>
            Responder
          </Button>
        </div>
      ) : (
        <p className="ast-perg__dica">Escolha uma opção, ou escreva outra resposta na caixa abaixo.</p>
      )}
    </div>
  )
}
